<!-- <p-messages [(value)]="companyFYNotice" [enableService]="false"></p-messages> -->
<div class="card">
    <p-accordion>
        <p-accordionTab header="Criteria to be deferred" [selected]="true">
            <form [formGroup]="filterFormGroup" #buildForm="ngForm" id="filterForm">
                <p-toolbar>
                    <!-- Direct or Indirect Toggle -->
                    <!-- <div>
                        <label style="
                                padding-right: 7px;
                                padding-left: 14px;
                                margin-bottom: 0px;
                                vertical-align: middle;
                            ">Direct</label>
                        <p-inputSwitch [style]="{ 'vertical-align': 'middle' }" formControlName="DoI"></p-inputSwitch>
                        <label style="
                                vertical-align: middle;
                                margin-bottom: 0px;
                                margin-top: 0px;
                            ">Indirect</label>
                    </div> -->

                    <!-- Contract -->
                    <p-floatLabel variant="on">
                        <!-- <p-multiSelect
                            [style]="{ 'min-width': '9em' }"
                            defaultLabel="Filter"
                            maxSelectedLabels="1"
                            selectedItemsLabel="{0} items selected."
                            appendTo="body"
                            [options]="contractsSelectItem"
                            [filter]="true"
                            formControlName="Contracts"
                            [virtualScroll]="true"
                            itemSize="30"
                        >
                        </p-multiSelect> -->
                        <p-select [autoDisplayFirst]="false" [style]="{ 'min-width': '12em' }" defaultLabel="Filter"
                            appendTo="body" [options]="contractsSelectItem" [filter]="true" formControlName="Contracts"
                            [virtualScroll]="true" itemSize="30">
                        </p-select>
                        <label for="float-dd">Contract</label>
                    </p-floatLabel>

                    <!-- Charge Number -->
                    <p-floatLabel variant="on">
                        <p-multiSelect formControlName="CN" maxSelectedLabels="1" [style]="{ 'min-width': '12em' }"
                            appendTo="body" [options]="chargeNumbersSelectItem" [filter]="true"
                            selectedItemsLabel="{0} items selected.">
                        </p-multiSelect>
                        <label for="float-dd">Charge Numbers</label>
                    </p-floatLabel>

                    <!-- Service Item -->
                    <p-floatLabel variant="on">
                        <p-multiSelect formControlName="SI" maxSelectedLabels="1" [style]="{ 'min-width': '12em' }"
                            appendTo="body" [options]="serviceItemsSelectItem" [filter]="true"
                            selectedItemsLabel="{0} items selected.">
                        </p-multiSelect>
                        <label for="float-dd">Service Items</label>
                    </p-floatLabel>

                    <!-- Manual Adjustment Date -->
                    <p-floatLabel variant="on">
                        <p-datepicker selectionMode="range" [monthNavigator]="true" [yearNavigator]="true"
                            yearRange="2000:2030" appendTo="body" [showIcon]="false" id="asofdate"
                            formControlName="Range">
                        </p-datepicker>
                        <label for="float-dd">Incurred Date Range</label>
                    </p-floatLabel>

                    <!--Apply-->
                    <button [disabled]="this.selectedcontracts.length == 0" type="button" pButton label="Review"
                        class="p-button-secondary" icon="pi pi-check" (click)="applyCriteria()"></button>

                    <!--Clear-->
                    <button type="button" pButton label="Clear" class="p-button-text"
                        (click)="clearCriteria()"></button>
                </p-toolbar>
            </form>
        </p-accordionTab>
    </p-accordion>

    <!-- <p-accordion>
        <p-accordionTab header="Multi Update" [selected]="this.IsMultiUpdate">
            <p-toolbar>

                <span class="p-float-label">
                    <p-datepicker selectionMode="single" [monthNavigator]="true" [yearNavigator]="true" yearRange="2000:2030" appendTo="body"
                        [showIcon]="false" id="billdate" [(ngModel)]="billDateForMultiUpdate">
                    </p-datepicker>
                    <label for="float-dd">Bill Date</label>
                </span>

                <button type="button" pButton pRipple icon="pi pi-pencil" iconPos="left" (click)="multiUpdate()"
                    class="p-button-secondary" label="Update" [disabled]="this.dbTableSelection.length > 0 ? false : true"></button>

            </p-toolbar>

        </p-accordionTab>
    </p-accordion> -->

    <p-accordion>
        <p-accordionTab header="Defer Billing" [selected]="true">
            <div id="defer-billing">
                <p-toolbar>
                    <p-floatLabel variant="on">
                        <p-datepicker selectionMode="single" [monthNavigator]="true" [yearNavigator]="true"
                            yearRange="2000:2030" appendTo="body" [showIcon]="false" id="billdate"
                            [(ngModel)]="billDateForMultiUpdate">
                        </p-datepicker>
                        <label for="float-dd">Bill Date</label>
                    </p-floatLabel>

                    <p-floatLabel variant="on">
                        <textarea pInputTextarea [(ngModel)]="noteForMultiUpdate"></textarea>
                        <label for="float-dd">Note</label>
                    </p-floatLabel>

                    <button style="margin-right: 3em !important" type="button" pButton pRipple icon="pi pi-pencil"
                        iconPos="left" (click)="multiUpdate()" class="p-button-secondary" [label]="updateBtnLabel"
                        [disabled]="
                            this.dbTableSelection.length > 0 ? false : true
                        "></button>

                    <button type="button" pButton hidden="true" class="p-button-secondary" label="Rebuild Invoice(s)"
                        disabled="true"></button>
                    <!-- <span class="p-float-label">
                        <p-multiSelect [options]="colsCanBeHidden" [(ngModel)]="selectedColumns" optionLabel="header"
                            (onChange)="onSelectedColumnsChange($event)" selectedItemsLabel="{0} columns selected"
                            [style]="{ minWidth: '200px' }" placeholder="Show/Hide Columns" maxSelectedLabels="1" appendTo="body"></p-multiSelect>
                        <label for="float-dd">Show/Hide Columns</label>
                    </span> -->
                    <button pButton pRipple type="button" class="p-button-text" label="Show/Hide Burdens"
                        (click)="burdensVisibility()"></button>
                    <div class="flex items-center">
                        <p-checkbox (onChange)="deferredOnlyToggle($event)"
                            [(ngModel)]="deferredOnly" [binary]="true"></p-checkbox>
                            <label class="ml-2">Show Deferred Only</label>
                    </div>

                    <!-- <button
                        type="button"
                        pButton
                        pRipple
                        icon="pi pi-file-excel"
                        (click)="dbTable.exportCSV()"
                        class="p-button-secondary p-mr-2"
                        pTooltip="Download"

                        tooltipPosition="bottom"
                    ></button> -->
                    <!-- <ef-column-search [elements]="elements"></ef-column-search> -->
                </p-toolbar>
                <p-table stripedRows #dbTable [value]="this.filteredBilling" scrollHeight="53vh" [scrollable]="true"
                    scrollDirection="both" editMode="row" (onEditInit_Summary)="onEditInit($event)"
                    (onRowEditSave)="onRowEditSave($event)" dataKey="Txnid" [columns]="cols"
                    [(selection)]="dbTableSelection" (onRowSelect)="onRowSelect($event)"
                    (onRowUnselect)="onRowUnselect($event)" (onHeaderCheckboxToggle)="onHeaderCheckboxToggle($event)">
                    <ng-template pTemplate="emptymessage">
                        <tr>
                            <td colspan="17" style="text-align: center">
                                <div class="tabulator-placeholder">
                                    <span> No Data Available </span>
                                </div>
                            </td>
                        </tr>
                    </ng-template>
                    <ng-template #header>
                        <tr>
                            <th pFrozenColumn [frozen]="IsColumnFrozen" class="edit-cell"></th>
                            <th pFrozenColumn [frozen]="IsColumnFrozen" class="status-cell">
                                <i class="pi pi-exclamation-circle" title="Status"></i>
                            </th>
                            <th pFrozenColumn [frozen]="IsColumnFrozen" class="select-cell">
                                <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
                            </th>

                            <!-- <th  pFrozenColumn [frozen]="IsColumnFrozen" pSortableColumn="Adjustmentstatus" class="tabulator-colgroup-header">
                                <div class="tabulator-col-content">
                                    Status
                                    <p-sortIcon field="Adjustmentstatus" ariaLabel="Activate to sort"
                                        ariaLabelDesc="Activate to sort in descending order"
                                        ariaLabelAsc="Activate to sort in ascending order">
                                    </p-sortIcon>
                                </div>
                            </th> -->
                            <th pFrozenColumn [frozen]="IsColumnFrozen" pSortableColumn="Txndate">
                                Incurred Date
                                <p-sortIcon field="Txndate" ariaLabel="Activate to sort"
                                    ariaLabelDesc="Activate to sort in descending order"
                                    ariaLabelAsc="Activate to sort in ascending order">
                                </p-sortIcon>
                            </th>
                            <th pFrozenColumn [frozen]="IsColumnFrozen" pSortableColumn="Billdate">
                                Bill Date
                                <p-sortIcon field="Billdate" ariaLabel="Activate to sort"
                                    ariaLabelDesc="Activate to sort in descending order"
                                    ariaLabelAsc="Activate to sort in ascending order">
                                </p-sortIcon>
                            </th>
                            <!-- <th  pFrozenColumn [frozen]="IsColumnFrozen" pSortableColumn="Modifieddate" class="tabulator-colgroup-header">
                                <div class="tabulator-col-content">
                                    Modified Date
                                    <p-sortIcon field="Modifieddate" ariaLabel="Activate to sort"
                                        ariaLabelDesc="Activate to sort in descending order"
                                        ariaLabelAsc="Activate to sort in ascending order">
                                    </p-sortIcon>
                                </div>
                            </th>
                            <th  pFrozenColumn [frozen]="IsColumnFrozen" pSortableColumn="Modifiedby" class="tabulator-colgroup-header">
                                <div class="tabulator-col-content">
                                    Modified By
                                    <p-sortIcon field="Modifiedby" ariaLabel="Activate to sort"
                                        ariaLabelDesc="Activate to sort in descending order"
                                        ariaLabelAsc="Activate to sort in ascending order">
                                    </p-sortIcon>
                                </div>
                            </th> -->
                            <th pFrozenColumn [frozen]="IsColumnFrozen" pSortableColumn="Txntype">
                                Type
                                <p-sortIcon field="Txntype" ariaLabel="Activate to sort"
                                    ariaLabelDesc="Activate to sort in descending order"
                                    ariaLabelAsc="Activate to sort in ascending order">
                                </p-sortIcon>
                                <p-columnFilter field="Txntype" matchMode="in" display="menu" [showMatchModes]="false"
                                    [showOperator]="false" [showAddButton]="false" class="ml-auto">
                                    <ng-template #filter let-value let-filter="filterCallback">
                                        <p-multiSelect defaultLabel="Filter"
                                            maxSelectedLabels="1" appendTo="body" [options]="
                                                this
                                                    .txnTypesFilterSelectItem
                                            " [filter]="true" styleClass="w-full" [ngModel]="value" (ngModelChange)="filter($event)">
                                        </p-multiSelect>
                                    </ng-template>
                                </p-columnFilter>
                            </th>
                            <th pFrozenColumn [frozen]="IsColumnFrozen" pSortableColumn="Task">
                                Task
                                <p-sortIcon field="Task" ariaLabel="Activate to sort"
                                    ariaLabelDesc="Activate to sort in descending order"
                                    ariaLabelAsc="Activate to sort in ascending order">
                                </p-sortIcon>
                            </th>
                            <th pSortableColumn="ServiceItem" *ngIf="this.SIColumnHidden == false">
                                Item
                                <p-sortIcon field="ServiceItem" ariaLabel="Activate to sort"
                                    ariaLabelDesc="Activate to sort in descending order"
                                    ariaLabelAsc="Activate to sort in ascending order">
                                </p-sortIcon>
                            </th>
                            <th pSortableColumn="Person" *ngIf="this.EmpColumnHidden == false">
                                Person
                                <p-sortIcon field="Person" ariaLabel="Activate to sort"
                                    ariaLabelDesc="Activate to sort in descending order"
                                    ariaLabelAsc="Activate to sort in ascending order">
                                </p-sortIcon>
                            </th>
                            <th pSortableColumn="PayrollItem" *ngIf="this.PIColumnHidden == false">
                                Payroll Item
                                <p-sortIcon field="PayrollItem" ariaLabel="Activate to sort"
                                    ariaLabelDesc="Activate to sort in descending order"
                                    ariaLabelAsc="Activate to sort in ascending order">
                                </p-sortIcon>
                            </th>
                            <th pSortableColumn="CostCenter" *ngIf="this.ccColumnVisible == true">
                                Cost Center
                                <p-sortIcon field="CostCenter" ariaLabel="Activate to sort"
                                    ariaLabelDesc="Activate to sort in descending order"
                                    ariaLabelAsc="Activate to sort in ascending order">
                                </p-sortIcon>
                            </th>
                            <th pSortableColumn="Hoursworked">
                                Hours
                                <p-sortIcon field="Hoursworked" ariaLabel="Activate to sort"
                                    ariaLabelDesc="Activate to sort in descending order"
                                    ariaLabelAsc="Activate to sort in ascending order">
                                </p-sortIcon>
                            </th>
                            <!-- <th  pSortableColumn="Invoiceenddate"  class="p-header-cell">
                                <div class="tabulator-col-content">
                                    Invoice End Date
                                    <p-sortIcon field="Invoiceenddate" ariaLabel="Activate to sort"
                                        ariaLabelDesc="Activate to sort in descending order"
                                        ariaLabelAsc="Activate to sort in ascending order">
                                    </p-sortIcon>
                                </div>
                            </th> -->
                            <th pSortableColumn="Invoicenbr">
                                Invoice #
                                <p-sortIcon field="Invoicenbr" ariaLabel="Activate to sort"
                                    ariaLabelDesc="Activate to sort in descending order"
                                    ariaLabelAsc="Activate to sort in ascending order">
                                </p-sortIcon>
                            </th>
                            <th pSortableColumn="Invoiceburdened">
                                Invoice Burdened
                                <p-sortIcon field="Invoiceburdened" ariaLabel="Activate to sort"
                                    ariaLabelDesc="Activate to sort in descending order"
                                    ariaLabelAsc="Activate to sort in ascending order">
                                </p-sortIcon>
                            </th>
                            <th *ngIf="this.IsBurdenHidden == false" pSortableColumn="Invoiceamount">
                                Invoiced Amount
                                <p-sortIcon field="Invoiceamount" ariaLabel="Activate to sort"
                                    ariaLabelDesc="Activate to sort in descending order"
                                    ariaLabelAsc="Activate to sort in ascending order">
                                </p-sortIcon>
                            </th>
                            <th *ngIf="this.IsBurdenHidden == false" pSortableColumn="Frcost">
                                FR Invoiced
                                <p-sortIcon field="Frcost" ariaLabel="Activate to sort"
                                    ariaLabelDesc="Activate to sort in descending order"
                                    ariaLabelAsc="Activate to sort in ascending order">
                                </p-sortIcon>
                            </th>
                            <th *ngIf="this.IsBurdenHidden == false" pSortableColumn="Ohcost">
                                OH Invoiced
                                <p-sortIcon field="Ohcost" ariaLabel="Activate to sort"
                                    ariaLabelDesc="Activate to sort in descending order"
                                    ariaLabelAsc="Activate to sort in ascending order">
                                </p-sortIcon>
                            </th>
                            <th *ngIf="this.IsBurdenHidden == false" pSortableColumn="Mhcost">
                                MH Invoiced
                                <p-sortIcon field="Mhcost" ariaLabel="Activate to sort"
                                    ariaLabelDesc="Activate to sort in descending order"
                                    ariaLabelAsc="Activate to sort in ascending order">
                                </p-sortIcon>
                            </th>
                            <th *ngIf="this.IsBurdenHidden == false" pSortableColumn="Gacost">
                                GA Invoiced
                                <p-sortIcon field="Gacost" ariaLabel="Activate to sort"
                                    ariaLabelDesc="Activate to sort in descending order"
                                    ariaLabelAsc="Activate to sort in ascending order">
                                </p-sortIcon>
                            </th>
                            <th *ngIf="this.IsBurdenHidden == false" pSortableColumn="Feecost">
                                Fee Invoiced
                                <p-sortIcon field="Feecost" ariaLabel="Activate to sort"
                                    ariaLabelDesc="Activate to sort in descending order"
                                    ariaLabelAsc="Activate to sort in ascending order">
                                </p-sortIcon>
                            </th>
                            <th pSortableColumn="TxnNotes">
                                Note
                                <p-sortIcon field="TxnNotes" ariaLabel="Activate to sort"
                                    ariaLabelDesc="Activate to sort in descending order"
                                    ariaLabelAsc="Activate to sort in ascending order">
                                </p-sortIcon>
                            </th>
                            <th pSortableColumn="Modifieddate">
                                Modified Date
                                <p-sortIcon field="Modifieddate" ariaLabel="Activate to sort"
                                    ariaLabelDesc="Activate to sort in descending order"
                                    ariaLabelAsc="Activate to sort in ascending order">
                                </p-sortIcon>
                            </th>
                            <th pSortableColumn="Modifiedby">
                                Modified By
                                <p-sortIcon field="Modifiedby" ariaLabel="Activate to sort"
                                    ariaLabelDesc="Activate to sort in descending order"
                                    ariaLabelAsc="Activate to sort in ascending order">
                                </p-sortIcon>
                            </th>
                        </tr>
                    </ng-template>
                    <ng-template #body let-db let-ri="rowIndex" let-edit="editing">
                        <tr [pEditableRow]="db">
                            <td pFrozenColumn [frozen]="IsColumnFrozen" class="edit-cell">
                                <button *ngIf="
                                        !edit &&
                                        (!editing?.Txnid ||
                                            !editing?.Txnid === db?.Txnid)
                                    " pButton pRipple type="button" pInitEditableRow icon="pi pi-pencil"
                                    (click)="onRowEditInit(db)" class="p-button-rounded p-button-text"
                                    style="height: 1.4rem; width: 1.4rem" title="Edit"></button>
                                <button *ngIf="edit" pButton pRipple type="button" pSaveEditableRow icon="pi pi-check"
                                    (click)="onRowEditSave(db)" class="p-button-rounded p-button-text p-button-success"
                                    style="
                                        margin-right: 0.5em;
                                        height: 1.4rem;
                                        width: 1.4rem;
                                    "></button>
                                <button *ngIf="edit" pButton pRipple type="button" pCancelEditableRow icon="pi pi-times"
                                    (click)="onRowEditCancel(db)" class="p-button-rounded p-button-text p-button-danger"
                                    style="height: 1.4rem; width: 1.4rem"></button>
                            </td>
                            <td pFrozenColumn [frozen]="IsColumnFrozen" class="status-cell">
                                <div style="height: 2em; align-self: center">
                                    <a (click)="ShowError.next(db)">
                                        <div>
                                            <ef-status-icon [status]="
                                                    db?.Status?.StatusCode
                                                " [message]="db?.Status?.Message">
                                            </ef-status-icon>
                                        </div>
                                    </a>
                                </div>
                            </td>
                            <td pFrozenColumn [frozen]="IsColumnFrozen" class="select-cell">
                                <p-tableCheckbox [value]="db"></p-tableCheckbox>
                            </td>

                            <!-- <td class="p-datatable-cell">
                                {{ db.Adjustmentstatus }}
                            </td>                             -->
                            <td pFrozenColumn [frozen]="IsColumnFrozen">
                                <span *ngIf="db.Txndate != null">
                                    {{
                                    moment(db.Txndate).format('MM/DD/YYYY')
                                    }}
                                </span>
                            </td>
                            <td pFrozenColumn [frozen]="IsColumnFrozen">
                                <p-cellEditor>
                                    <ng-template pTemplate="input">
                                        <p-datepicker [(ngModel)]="billDate" [minDate]="minDate" appendTo="body"
                                            [yearNavigator]="true" [monthNavigator]="true"
                                            yearRange="2010:2030"></p-datepicker>
                                    </ng-template>
                                    <ng-template pTemplate="output">
                                        <span *ngIf="db.Billdate != null">
                                            {{
                                            moment(db.Billdate).format(
                                            'MM/DD/YYYY'
                                            )
                                            }}
                                        </span>
                                    </ng-template>
                                </p-cellEditor>
                            </td>
                            <!-- <td class="p-datatable-cell">
                                <span *ngIf="db.Modifieddate != null">
                                    {{ moment(db.Modifieddate).format('MM/DD/YYYY') }}
                                </span>
                            </td>
                            <td class="p-datatable-cell">
                                {{ db.Modifiedby }}
                            </td> -->
                            <td pFrozenColumn [frozen]="IsColumnFrozen">
                                {{ db.Txntype }}
                            </td>
                            <td pFrozenColumn [frozen]="IsColumnFrozen">
                                <label [title]="this.findTask(db)" style="line-height: 0.4em">
                                    {{ db.Task }}
                                </label>
                            </td>
                            <td *ngIf="this.SIColumnHidden == false">
                                <!--Item-->
                                {{ db.ServiceItem }}
                            </td>
                            <td *ngIf="this.EmpColumnHidden == false">
                                {{ db.Person }}
                            </td>
                            <td *ngIf="this.PIColumnHidden == false">
                                <!--Payroll Item-->
                                {{ db.PayrollItem }}
                            </td>
                            <td *ngIf="this.ccColumnVisible == true">
                                <!--Cost Center-->
                                {{ db.CostCenter }}
                            </td>
                            <td>
                                <!--Hoursworked-->
                                {{ db.Hoursworked }}
                            </td>
                            <!-- <td class="p-datatable-cell">
                               Invoiceenddate
                                {{ db.Invoiceenddate }}
                            </td> -->
                            <td>
                                <!--Invoicenbr-->
                                {{ db.Invoicenbr }}
                            </td>
                            <td>
                                <!--Invoiceburdened-->
                                {{
                                currencyFormatter.format(
                                +db.Invoiceburdened
                                )
                                }}
                            </td>
                            <td *ngIf="this.IsBurdenHidden == false">
                                <!--Invoiceamount-->
                                {{
                                currencyFormatter.format(+db.Invoiceamount)
                                }}
                            </td>
                            <td *ngIf="this.IsBurdenHidden == false">
                                <!--Frcost-->
                                {{ currencyFormatter.format(+db.Frcost) }}
                            </td>
                            <td *ngIf="this.IsBurdenHidden == false">
                                <!--Ohcost-->
                                {{ currencyFormatter.format(+db.Ohcost) }}
                            </td>
                            <td *ngIf="this.IsBurdenHidden == false">
                                <!--Mhcost-->
                                {{ currencyFormatter.format(+db.Mhcost) }}
                            </td>
                            <td *ngIf="this.IsBurdenHidden == false">
                                <!--Gacost-->
                                {{ currencyFormatter.format(+db.Gacost) }}
                            </td>
                            <td *ngIf="this.IsBurdenHidden == false">
                                <!--Feecost-->
                                {{ currencyFormatter.format(+db.Feecost) }}
                            </td>
                            <td>
                                <!--TxnNotes-->
                                <p-cellEditor>
                                    <ng-template pTemplate="input">
                                        <input pInputText type="text" [(ngModel)]="db.TxnNotes" />
                                    </ng-template>
                                    <ng-template pTemplate="output">
                                        <label [title]="db.TxnNotes">{{
                                            db.TxnNotes
                                            }}</label>
                                    </ng-template>
                                </p-cellEditor>
                            </td>
                            <td>
                                <span *ngIf="db.Modifieddate != null">
                                    {{
                                    moment(db.Modifieddate).format(
                                    'MM/DD/YYYY'
                                    )
                                    }}
                                </span>
                            </td>
                            <td>
                                {{ db.Modifiedby }}
                            </td>
                        </tr>
                    </ng-template>
                </p-table>
            </div>
        </p-accordionTab>
    </p-accordion>
</div>
